import { useMemo } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';


export default function Pagination({
  totalRows,
  tablePage,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}) {
  const totalPages = Math.max(1, Math.ceil(totalRows / Math.max(1, rowsPerPage)));
  const currentPage = Math.min(Math.max(1, tablePage), totalPages);

  const pageNumbers = useMemo(() => {
    const maxButtons = 5;
    const pages = [];

    if (totalPages <= maxButtons) {
      for (let i = 1; i <= totalPages; i += 1) pages.push(i);
      return pages;
    }

    const left = Math.max(1, currentPage - 1);
    const right = Math.min(totalPages, currentPage + 1);

    pages.push(1);
    if (left > 2) pages.push("...");

    for (let i = left; i <= right; i += 1) {
      if (i !== 1 && i !== totalPages) pages.push(i);
    }

    if (right < totalPages - 1) pages.push("...");
    pages.push(totalPages);

    return pages.filter((value, index, array) => array.indexOf(value) === index);
  }, [currentPage, totalPages]);

  const goToPage = (nextPage) => {
    const page = Math.min(Math.max(1, Number(nextPage) || 1), totalPages);
    onPageChange(page);
  };

  const firstRow = totalRows === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
  const lastRow = Math.min(currentPage * rowsPerPage, totalRows);


  return (
    <>
      {totalRows > 0 && (
        <div className="sims-pagination">

          <div className="sims-pagination-left">
            <span className="sims-page-info">
              Menampilkan <b>{firstRow}-{lastRow}</b> dari{" "}
              <b>{totalRows}</b> data
            </span>

            <select
              className="sims-page-size"
              value={rowsPerPage}
              onChange={(event) => {
                const value = Number(event.target.value) || 10;
                onRowsPerPageChange(value);
              }}
            >
              <option value={10}>10 / halaman</option>
              <option value={25}>25 / halaman</option>
              <option value={50}>50 / halaman</option>
              <option value={100}>100 / halaman</option>
            </select>
          </div>

          <div className="sims-pagination-right">
            <button
              type="button"
              className="sims-page-nav"
              onClick={() => goToPage(currentPage - 1)}
              disabled={currentPage <= 1}
            >
              <FontAwesomeIcon icon={faChevronLeft} />
                <span>Sebelumnya</span>
            </button>

            <div className="sims-page-numbers">
              {pageNumbers.map((page, index) =>
                page === "..." ? (
                  <span
                    key={`dots-${index}`}
                    className="sims-page-dots"
                  >
                    ...
                  </span>
                ) : (
                  <button
                    type="button"
                    key={`page-${page}`}
                    className={`sims-page-number ${
                      page === currentPage ? "active" : ""
                    }`}
                    onClick={() => goToPage(page)}
                  >
                    {page}
                  </button>
                )
              )}
            </div>

            <button
              type="button"
              className="sims-page-nav"
              onClick={() => goToPage(currentPage + 1)}
              disabled={currentPage >= totalPages}
            >
              <span>Selanjutnya</span>
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
        </div>
      )}
    </>
  );
}
  